import React from 'react';

const Error404 = () => {
    return (
        <div>
            <h2>
                This is 404 error
            </h2>
        </div>
    );
};

export default Error404;